import React, { useState, useEffect, useRef } from "react";
import { editAccountProfile } from "utils/api";
import { fetchUser } from "features/userSlice";
import { Input, theme, Affix, Button, FloatButton, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import "../css/Gallery.scss";
import { useTranslation } from "react-i18next";
import { css } from "@emotion/css";
import { ACCOUNT_TYPE } from "utils/consts";
import { generateInviteKey } from "utils/misc";
import { useDispatch, useSelector } from "react-redux";

function HubInviteLink() {
  theme.useToken();
  const { t } = useTranslation();
  const [inviteLink, setInviteLink] = useState(null);
  const dispatch = useDispatch();
  const user = useSelector((state) => state.user.user);
  const [messageApi, contextHolder] = message.useMessage();
  const inputRef = useRef(null);

  useEffect(() => {
    if (user) {
      if (user.invite_key) {
        setInviteLink(
          window.location.host + "/" + user.url + "/invite/" + user.invite_key
        );
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const copyInviteLink = () => {
    if (inviteLink) {
      inputRef.current.select();
      document.execCommand("copy");
      messageApi.success("Copied");
    }
  };

  const generateLink = async () => {
    const key = generateInviteKey();
    setInviteLink(window.location.host + "/" + user.url + "/invite/" + key);
    var edit_data = {
      invite_key: key,
    };
    await editAccountProfile(edit_data, user._id.$oid, ACCOUNT_TYPE.HUB);
    dispatch(fetchUser({ id: user._id.$oid, role: ACCOUNT_TYPE.HUB }));
  };

  // Add some kind of error 403 code
  return (
    <>
      <div className="gallery-container">
        <FloatButton.BackTop />
        {contextHolder}
        <Affix offsetTop={10}>
          <div style={{ display: "flex" }}>
            <Button
              className={css`
                margin-top: 10px;
                margin-bottom: 10px;
                @media only screen and (max-width: 640px) {
                  display: none;
                }
              `}
              type="primary"
              onClick={() => {
                generateLink();
              }}
            >
              {t("sidebars.generate_invite_link")}
            </Button>
            <div
              style={{
                display: "flex",
                lineHeight: "3rem",
                fontSize: "1.2rem",
              }}
            >
              <div style={{ marginLeft: "1rem", marginRight: "1rem" }}>
                <Input
                  style={{ width: "25rem" }}
                  value={inviteLink}
                  ref={inputRef}
                  readOnly
                />
              </div>
              <div
                style={{ cursor: "pointer" }}
                onClick={() => copyInviteLink()}
              >
                <CopyOutlined />
              </div>
            </div>
          </div>
        </Affix>
      </div>
    </>
  );
}

export default HubInviteLink;
